export default __webpack_public_path__ + "static/media/watch.00240348.svg";